document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));

        let counter = 0;
        let selector = ".bss-b2b-qty-table-wrapper"
        const interval = setInterval(() => {
            let element = document.querySelector(selector);
            if (element) {
              clearInterval(interval);
              const els = document.querySelectorAll('.border-radius-left-table-qb');
              els.forEach(el => {
              if (el && el.textContent.includes('≥')) {
                const raw = el.textContent.replace(/[^\d]/g, ""); // "20000"
                const number = Number(raw).toLocaleString(); // "20,000"

                el.innerHTML = `<span class="bss-above-text">Above</span> ${BSS_B2B.formatMoney(raw * 100)}`;
              }
            });
            } else {
                counter += 100;
                if (counter >= 10000) {
                    clearInterval(interval);
                }
            }
        }, 100); 

        setTimeout(() => {
          hideFirstTableIfDuplicate();
        }, 1000);
      }, 2000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('halo-cart-content')) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});

document.addEventListener("BSS:changeVariantQV", e => {
  setTimeout(() => {
    if (BSS_B2B.page.isProductPage()) return

    const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  }, 1000);
});

let counter = 0;
let selector = ".bss-b2b-qty-table-wrapper"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        clearInterval(interval);
        const els = document.querySelectorAll('.border-radius-left-table-qb');
        els.forEach(el => {
          if (el && el.textContent.includes('≥')) {
            const raw = el.textContent.replace(/[^\d]/g, ""); // "20000"
            const number = Number(raw).toLocaleString(); // "20,000"

            el.innerHTML = `<span class="bss-above-text">Above</span> ${BSS_B2B.formatMoney(raw * 100)}`;
          }

          hideFirstTableIfDuplicate();
        });
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

function hideFirstTableIfDuplicate() {
  document.querySelectorAll('product-form-component').forEach(product => {
    const tables = product.querySelectorAll('.bss-b2b-cart-item-qty-table');

    if (tables.length > 1) {
      // reset class cũ
      tables.forEach(t => t.classList.remove('bss-hide-first-table'));

      // chỉ ẩn table đầu
      tables[0].classList.add('bss-hide-first-table');
    }
  });
}

hideFirstTableIfDuplicate();